const Mask = (($) => {

    const NAME = 'mask';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        pattern: '{{*}}',
        persistent: false
    };
    const Selector = {
        CLASS_NAME: `.js-${NAME}`
    }

    class Mask {
        constructor(element, config) {
            this._config = config;
            this._element = element;
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }


        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Mask(this, config);
                    $this.data(DATA_KEY, data).formatter(config);
                }
            });
        }
    }

    $(() => Mask._jQueryInterface.call($(Selector.CLASS_NAME)));
    $(document).ajaxStop(() => Mask._jQueryInterface.call($(Selector.CLASS_NAME)));

    $.fn[NAME] = Mask._jQueryInterface;
    $.fn[NAME].Constructor = Mask;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Mask._jQueryInterface;
    }

    return Mask;
})(jQuery);